import { z } from "zod";
import { definePersistedSlice } from "../runtime/definePersistedSlice";

/** Zod schema for authentication session fields. */
const AuthStateSchema = z.object( {
    "token": z.string().nullable().
        default( null ),
    "userRole": z.string().nullable().
        default( null ),
} );

/** Persisted auth session (token + role). */
export type AuthState = z.infer<typeof AuthStateSchema>;

/** Default unauthenticated state. */
export const AUTH_DEFAULT: AuthState = AuthStateSchema.parse( {} );

/**
 * Auth slice (token + userRole).
 *
 * @remarks
 * Stored via @aparajita/capacitor-secure-storage (Keychain / Keystore on native).
 * Web dev builds use the plugin's localStorage fallback (not encrypted).
 */
export const authSlice = definePersistedSlice<AuthState>( {
    "key":            "auth",
    "currentVersion": 1,
    "storage":        "secure",
    "eager":          true,
    "schema":         AuthStateSchema,
    "default":        () => AUTH_DEFAULT,
    "migrations":     {},
} );
